(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-style-links"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('collection-style-links')) {
    customElements.define(
      'collection-style-links',
      class CollectionStyleLinks extends HTMLElement {
        connectedCallback() {
          this.links = [...this.querySelectorAll('.collection-style-links__link')];
          this.links.forEach((link) => link.addEventListener('click', this.onClick.bind(this)));
          this.updateCurrentLink();
          window.addEventListener('popstate', () => this.updateCurrentLink());
        }

        updateCurrentLink() {
          this.links.forEach((link) => {
            const isCurrent = new URL(link.href).pathname === window.location.pathname;
            if (isCurrent) {
              link.setAttribute('aria-current', 'page');
            } else {
              link.removeAttribute('aria-current');
            }
          });
        }

        async onClick(event) {
          if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) {
            return;
          }

          const productGrid = document.getElementById('ProductGridContainer');
          const productList = document.getElementById('product-grid');
          const filters = document.getElementById('main-collection-filters');
          if (!productGrid || !productList || !filters) return;

          event.preventDefault();
          const link = event.currentTarget;
          const targetUrl = new URL(link.href);
          const sectionId = productList.dataset.id;
          const requestUrl = `${targetUrl.pathname}?section_id=${encodeURIComponent(sectionId)}`;

          this.links.forEach((item) => item.removeAttribute('aria-current'));
          link.setAttribute('aria-current', 'page');
          productGrid.querySelector('.collection')?.classList.add('loading');

          try {
            const response = await fetch(requestUrl);
            if (!response.ok) throw new Error(`Collection filter request failed: ${response.status}`);

            const responseText = await response.text();
            const parsedDocument = new DOMParser().parseFromString(responseText, 'text/html');
            const nextGrid = parsedDocument.getElementById('ProductGridContainer');
            const nextFilters = parsedDocument.getElementById('main-collection-filters');
            if (!nextGrid || !nextFilters) throw new Error('Collection filter response is incomplete');

            productGrid.innerHTML = nextGrid.innerHTML;
            filters.innerHTML = nextFilters.innerHTML;
            history.pushState({ searchParams: '' }, '', targetUrl.pathname);
            this.scrollIntoView({ behavior: 'instant', block: 'start' });
          } catch (error) {
            window.location.assign(link.href);
          }
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
